var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"text-center transaction-details"},[_c('button',{staticClass:"btn btn-primary",attrs:{"id":"go-sell"}},[_vm._v("Proceed to Payment")]),_c('div',{attrs:{"id":"wrap-content"}})])}
var staticRenderFns = []

export { render, staticRenderFns }